import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { Trash2 } from "lucide-react";

const DeleteConfirmationModal = ({
  open,
  onClose,
  item,
  onConfirm,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Trash2 size={20} color="error" />
        <Typography variant="h6" color="error">
          Delete Product Item
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Alert severity="warning" sx={{ mb: 3 }}>
            This action cannot be undone. The product item will be permanently
            deleted.
          </Alert>

          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete this product item?
          </Typography>

          {/* <Box sx={{ mt: 2, p: 2, bgcolor: "error.light", borderRadius: 1 }}>
            <Typography variant="subtitle2" color="error.contrastText">
              Item to Delete:
            </Typography>
            <Typography variant="h6" sx={{ mt: 1, color: "error.contrastText" }}>
              {item?.medicineItemName}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: "error.contrastText" }}>
              {item?.description}
            </Typography>
            <Typography variant="caption" sx={{ mt: 1, display: "block", color: "error.contrastText" }}>
              ID: {item?.id}
            </Typography>
          </Box> */}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          startIcon={<Trash2 size={16} />}
          disabled={loading}
        >
          {loading ? "Deleting ..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
